export default "<tabset>\r\n  <tab heading=\"Config 1\">Config content 1</tab>\r\n  <tab heading=\"Config 2\">Config content 2</tab>\r\n</tabset>\r\n";